import { isEmpty, isNil } from 'lodash';

import { countries, CountryCode } from './countries';
import { deCountriesLocale, enCountriesLocale, frCountriesLocale, nlCountriesLocale } from './i18n/countries';
import { Language } from './types/dto-app';

const IP2CountryAddress = 'https://ip2c.org/self';

export const DEFAULT_COUNTRY_CODE = 'BE' satisfies CountryCode;
export const DEFAULT_DIAL_CODE: string = countries[DEFAULT_COUNTRY_CODE].dial_code;

export const getCountryCodeFromDialCode = (dialCode: string): CountryCode | null => {
  if (isNil(dialCode) || isEmpty(dialCode)) {
    return null;
  }
  const country = Object.values(countries).find((foundCountry) => foundCountry.dial_code === dialCode);
  return isNil(country) ? null : country.code;
};

export const getDialCodeCodeFromCountryCode = (countryCode: CountryCode): string | null => {
  if (isNil(countryCode) || isEmpty(countryCode)) {
    return null;
  }
  const country = Object.values(countries).find((foundCountry) => foundCountry.code === countryCode);
  return isNil(country) ? null : country.dial_code;
};

export const getCountryCodeAndNameOfClient = async () => {
  const response = await fetch(IP2CountryAddress);
  const reader = (response.body as unknown as ReadableStream<Uint8Array>).getReader();
  const value = await reader.read();
  const decodedValue = new TextDecoder('utf-8').decode(value.value);
  const [success, countryCode, , countryName] = decodedValue.split(';');
  if (success)
    return {
      countryCode: countryCode as CountryCode,
      countryName,
      countryDialCode: getDialCodeCodeFromCountryCode(countryCode as CountryCode),
    };
  else return { countryCode: null, countryName: null, countryDialCode: null };
};

export const getCountriesLocale = (language?: Language | null) => {
  if (language === Language.FR) {
    return frCountriesLocale;
  }
  if (language === Language.NL) {
    return nlCountriesLocale;
  }
  if (language === Language.DE) {
    return deCountriesLocale;
  }
  return enCountriesLocale;
};

export const getCountryName = (countryCode: string | null | undefined, language?: Language | null): string => {
  if (!countryCode) {
    return '';
  }
  return getCountriesLocale(language).countries[countryCode.toUpperCase()] ?? '';
};
export const getCountryFromName = (countryName: string | null | undefined): string | null => {
  const country = Object.values(countries).find(
    (currentCountry) =>
      currentCountry.name === countryName ||
      frCountriesLocale.countries[currentCountry.code] === countryName ||
      nlCountriesLocale.countries[currentCountry.code] === countryName ||
      deCountriesLocale.countries[currentCountry.code] === countryName ||
      enCountriesLocale.countries[currentCountry.code] === countryName
  );
  return isNil(country) ? null : country.code;
};
